import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";
import { FormRenderGroupTypes } from "../Shared/Components/FormRenderer/FormRenderGroup.types";

export const tagFields: FormField[] = [
	{
		name: "name",
		label: "Nazwa tagu",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Nazwa tagu",
		group: FormRenderGroupTypes.basic,
	},
];
